import React from 'react';
import GenericDialog from '../../common/GenericDialog';

const PrintTestColumnsDialog = ({
                             open,
                             onClose,
                             onPrintTest,
                             selectedSingleTest,
                         }) => {
    return (
        <GenericDialog
            title={`Print: ${selectedSingleTest?.name}`}
            open={open}
            onClose={onClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: {type: 'text'},
                },
                {
                    name: 'Single column',
                    callback: () => onPrintTest(1),
                },
                {
                    name: 'Twin column',
                    callback: () => onPrintTest(2),
                },
            ]}
        >
            <p>What format would you like for your test?</p>
            <p className="ch-warning-text">Note: Twin column might not be suitable for all material</p>
        </GenericDialog>
    );
};

export default PrintTestColumnsDialog;
